import { __read, __spread } from "tslib";
export function injectPropsIfTargetNotExisted(columns, targetColumnKey, columnProps, postposition) {
    if (columnProps === void 0) { columnProps = {}; }
    if (postposition === void 0) { postposition = false; }
    // 查找注入的目标列
    var targetColumnIndex = -1;
    if (targetColumnKey) {
        targetColumnIndex = columns.findIndex(function (x) { return x.key === targetColumnKey; });
        if (targetColumnIndex === -1) {
            console.warn("Table addon can not find column \"" + targetColumnKey + "\", did you rename or misspell it?");
        }
    }
    // 没有目标列，创建一个列
    if (+targetColumnIndex === -1) {
        columnProps.ignore = true;
        return postposition ? __spread(columns, [columnProps]) : __spread([columnProps], columns);
    }
    return columns;
}
//# sourceMappingURL=inject-props-if-target-not-existed.js.map